export class PickTask {
    ID:number;
    CLIENT_ID:number;
    USER_ID:number;
    PROJECT_ID:number;
    SUBTASK_MODULE_ID:number;
    SUBTASK_FEATURE_ID:number;
    PARENT_TASK_ID:number;
    DATE:any;
TASK_ID
}